interface IInitialAvatarComponentProps {
	name: string;
}

/** A rounded tile showing the first letter of a name, used in lists in place of a photo. */
export function InitialAvatarComponent({ name }: IInitialAvatarComponentProps) {
	return (
		<div className="grid size-12 shrink-0 place-items-center overflow-hidden rounded-2xl bg-brand-soft font-bold text-brand">
			<span aria-hidden="true">{name.charAt(0).toUpperCase()}</span>
		</div>
	);
}
